import { render, staticRenderFns } from "./OrgLayout.vue?vue&type=template&id=04861572"
import script from "./OrgLayout.vue?vue&type=script&lang=js"
export * from "./OrgLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports